// Procedural FX constants (MVP defaults)

// ── Feature A: Coastline Foam + Water Shimmer ────────────────────────────────

export const FOAM_ALPHA        = 0.45;   // opacity of foam stroke
export const FOAM_WIDTH_PX     = 2.5;   // stroke width
export const FOAM_JITTER_PX    = 0.9;   // tiny wobble amplitude
export const FOAM_ANIM_SPEED   = 0.22;  // how fast jitter changes (buckets/sec)
export const FOAM_DASH_LEN     = 6;
export const FOAM_DASH_GAP     = 8;

export const WATER_SHIMMER_ALPHA = 0.18; // max shimmer fill opacity
export const WATER_SHIMMER_SPEED = 0.10; // bucket update rate
export const WATER_SHIMMER_SCALE = 0.015; // noise scale in world-ish coords

// ── Feature B: Biome Texture Overlay ────────────────────────────────────────

export const TEXTURE_ALPHA_BASE = 0.10;

export const TEXTURE_ALPHA_BY_TYPE = {
  grass:      0.14,
  grassland:  0.12,
  desert:     0.18,
  snow:       0.11,
  mountain:   0.14,
  deadplains: 0.16,
  ocean:      0.00,
};

export const NOISE_SCALE           = 0.035; // noise frequency (tile coords)
export const REGION_TINT_STRENGTH  = 0.03;  // subtle brightness variance across regions

// ── Feature C: Overlay Depth Pass ───────────────────────────────────────────

export const SHADOW_ALPHA    = 0.35;
export const SHADOW_SCALE_X  = 0.55;
export const SHADOW_SCALE_Y  = 0.22;
export const SHADOW_OFFSET_Y = 10;   // offset toward "ground" in base-hex units

export const RIM_ALPHA         = 0.06;
export const HOVER_HALO_ALPHA  = 0.30;  // white ring inside the hovered tile
export const HOVER_HALO_WIDTH  = 2;
export const SPARKLE_COUNT     = 6;
export const SPARKLE_LIFE_MS   = 450;
